(function ($, Drupal, once) {
  Drupal.behaviors.halifax_clickable_card = {
    attach: (context) => {
      once('halifax_clickable_card', '.js-clickable-card', context).forEach(
        (card) => {
          card.style.cursor = 'pointer';
          let down;
          let up;
          const link = card.querySelector('a');

          card.onmousedown = () => {
            down = Date.now();
          };

          card.onmouseup = () => {
            up = Date.now();
            if (up - down < 200) {
              link.click();
            }
          };
        }
      );
    },
  };
})(jQuery, Drupal, once);
